export const orderStatusList =[
    { value: "pending", label: "Pending" },
    { value: "re-register", label: "Re-register" },
    { value: "preparing_initial_offer", label: "Preparing the initial offer to the client" },
    { value: "final_issuance_proforma_invoice", label: "Final issuance of proforma invoice" },
    { value: "awaiting_payment", label: "Awaiting payment from the buyer" },
    { value: "under_review_approval", label: "Under review and approval by the bank" },
    { value: "final_purchase_process", label: "In the final purchase process" },
    { value: "finalizing_purchase_delivery", label: "Finalizing the purchase and delivery to shipping company" },
    { value: "product_on_the_way", label: "The desired product is on the way" },
    { value: "product_delivered", label: "The desired product has been delivered to the buyer" },
    { value: "end_of_order", label: "End of order" }
]

export const statusList =[
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" }
]

export const orderRequest ={
    id:null,
    slug:null,
    follow_up_date:"",
    title:null,
    time_create_view:null,
    time_update_view:null,
    is_new_customer:null,
    send_from:'admin',
    customer:{
        id:null,
        email:null,
        first_name:null,
        last_name:null,
        name:null,
        avatar:null
    },
    order:{
        product:{
            title:null,
            company:null,
            quantity:null,
            quantity_unit:null,
            description:null,
        },
        delivery:{
            country:null,
            state:null,
            city:null,
            zip_code:null,
            address:null,
            location:{
                lat:null,
                long:null,
            },
        },
        attachments:[],
        status:null
    }
}

export const BuildStatus : Record<number, string> = {
    0: "not-build",
    1: "building",
    2: "built",
    3: "build-error",
}

export const PowerStatus : Record<number, string> = {
    0: "pending",
    1: "running",
    3: "paused",
    4: "shutdown",
    6: "crashed",
    7: "suspended",
}

export const StatusList : Record<number, string> = {
    0: "draft",
    2: "activeRequest",
    5: "active",
    10: "suspend",
    [-1]: "delete",
}

export function getVmStatus(buildStatus: number, powerStatus: number) {
    if (buildStatus !== 2) {
        const str = BuildStatus[buildStatus] || "unknown"
        return `title.${str}`
    }
    const str = PowerStatus[powerStatus] || "unknown"
    return `title.${str}`
}


export function getServiceStatus(status: number) {
    const txt = StatusList[status] || "unknown"
    return `title.${txt}`
}

export function getServiceStatusColor(status: null) {
    if (status === 0) return "text-gray-500 inline-block";
    if (status === 5) return "text-green-700 inline-block animate-pulse";
    if (status === 2) return "text-orange-500 inline-block animate-pulse";
    if (status === 10) return "text-red-500 inline-block";
    if (status === -1) return "text-black inline-block";
    return "text-purple-500 inline-block"
}

export function getVmIcon(buildStatus: number, powerStatus: number) {
    if (buildStatus !== 2) {
        if (buildStatus === 0) return ["EllipsisIcon", "animate-bounce text-red-500 inline-block"];
        if (buildStatus === 1) return ["Loader", "animate-spin text-yellow-500 inline-block"];
        if (buildStatus === 3) return ["CircleAlert", "animate-spin text-red-700 inline-block"];
    }
    if (powerStatus === 0) return ["ScreenShareOff", "text-gray-500 inline-block"];
    if (powerStatus === 1) return ["MonitorPlay", "text-green-800 inline-block"];
    if (powerStatus === 3) return ["MonitorPause", "text-yellow-500 inline-block"];
    if (powerStatus === 4) return ["MonitorStop", "text-black inline-block"];
    if (powerStatus === 6) return ["MonitorOff", "text-red-600 inline-block"];
    if (powerStatus === 7) return ["MonitorCog", "text-orange-600 inline-block"];

    return ["AlertCircle", "text-red-700 inline-block"];
}